import { takeLatest } from 'redux-saga/effects';
import { LOAD_OPTIONS_SUCCESS } from '@gcc/configurator/dist/actions/actionTypes';
import { UPDATE_THD_STORE_INFO } from '../../actions/actionTypes';
import safeSaga from '../safeSaga';
import getQuickViewOptionPricing from './quickViewPricing';

const safeGetQuickViewPricing = safeSaga(getQuickViewOptionPricing);

export default function* quickViewSaga() {
  yield takeLatest([LOAD_OPTIONS_SUCCESS, UPDATE_THD_STORE_INFO], safeGetQuickViewPricing);
}
